import { useState, useEffect } from "react";
import { auth } from "../firebase";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const useOtherUsersData = (userData) => {
  const [otherUsersData, setOtherUsersData] = useState([]);

  useEffect(() => {
    const fetchOtherUsersData = async () => {
      try {
        const db = getFirestore();
        const usersCollection = collection(db, "users");
        const q = query(usersCollection, where("point", "==", userData?.point));
        const querySnapshot = await getDocs(q);

        const otherUsers = [];
        querySnapshot.forEach((doc) => {
          if (doc.id !== auth.currentUser.uid) {
            otherUsers.push({ id: doc.id, ...doc.data() });
          }
        });

        setOtherUsersData(otherUsers);
      } catch (error) {
        console.error("Error fetching other users data:", error);
      }
    };

    if (userData?.point) {
      fetchOtherUsersData();
    }
  }, [userData]);

  return otherUsersData;
};

export default useOtherUsersData;
